import { Layout } from "ui-components/Layout";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { formRender, initialValues, companyValidations } from "./company-schema";
import CompanyInfo from "./components/CompanyInfo";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getCompanyByCode, editCompany } from "services/data.internal.service";
import { useState } from "react";
import { Success, Error_ } from "ui-components/Alert";
import { useLocation } from "react-router-dom";
import { SaveButton } from "ui-components/Form";

function EditCompany() {
  const location = useLocation();
  const { companyCode } = location.state;
  const [alert, setAlert] = useState(null);
  const [formValues, setFormValues] = useState(null);
  const onSuccess = (data) => setAlert(<Success data={data} onChange={setAlert} />);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);
  const queryClient = useQueryClient();
  useQuery({
    queryKey: ["company", { companyCode }],
    queryFn: () => getCompanyByCode(companyCode),
    onSuccess: (data) => setFormValues(data.data.data),
    onError,
  });
  const editCompanyMutation = useMutation(editCompany, {
    onSuccess,
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    values: formValues,
    resolver: yupResolver(companyValidations),
  });
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
  } = form;
  const infoProps = {
    formRender,
    mode: "EDIT",
    control,
    errors,
  };
  const onSubmit = (data) => {
    editCompanyMutation.mutate(data, {
      onSuccess: () => queryClient.invalidateQueries(["company"]),
    });
  };
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <CompanyInfo {...infoProps} />
        <SaveButton label="Save" disabled={!isDirty} url="/setup/company" />
      </form>
    </Layout>
  );
}

export default EditCompany;
